import PageCDVerify from '~/components/CDVerify'

export default PageCDVerify